import { useSelector } from 'react-redux'

const useProjectId = () => {
  const selector = state => state.appReducer.appProject
  const projectId = useSelector(selector)
  return { projectId }
}

export default useProjectId
